<template>
  <div id="game">
    <h1 class="" v-if="score.settings">
      <ClassicButton
        :label="score.settings.name"
        flexOption=""
        classButton="maintitle underline"
        @buttonClick="showModal = true"
      />
    </h1>

    <Score :score="score" />

    <Modal
      :enableEsc="false"
      :showModal="showModal"
      @modaleOpen="showModal = $event"
      @closeModal="showModal = false"
      pickerTitle=""
     >
      <template v-slot:modalHeader>
        <button
          @click.prevent="showModal = !showModal"
          type="button"
          title="fermer"
          class="modal-header modal-gray"
        >
          &times;
        </button>
      </template>
      <template v-slot:modalBody>
        <div class="modal-body container">
          <div class="flex">
            <button
              type="button"
              class="modal-close"
              @click.prevent="showModal = false"
            >
              &times;
            </button>
          </div>

          <h2 class="modal-title">
            Qui joue à {{ score.settings.name }} cette fois-ci ?
          </h2>

          <Gamers
            :players="score.players"
            @currentPlayers="updatePlayers($event)"
            @removePlayer="removeSheet($event)"
          />

          <div class="flex">
            <ClassicButton
              v-if="!score.startTime"
              :disabled="
                !score.players || score.players.length == 0 ? true : false
              "
              @buttonClick="startDate('startTime'); showModal = false;"
              label="Début de partie"
              classButton="button secondaryButton button-large"
            />

            <ClassicButton
              v-if="score.startTime && !score.endTime"
              @buttonClick="startDate('endTime'); showModal = false;"
              label="Fin de partie"
              classButton="button secondaryButton button-large"
            />


          </div>
        </div>
      </template>
    </Modal>

    <div
      class="mt-4 text-sm text-center text-gray-500 "
      v-if="score.startTime && score.endTime"
    >
      Partie débutée
      <span class="text-gray-700">
        le {{ score.startTime | humanizeDate }}
      </span>

      et terminée
      <span class="text-sm text-gray-600">
        le {{ score.endTime | humanizeDate }}
      </span>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/ui/generic/Modal.vue";
import Gamers from "@/components/data/Gamers.vue";
import Score from "@/components/data/Score.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";

export default {
  name: "game",
  data() {
    return {
      showModal: false,
      list_scores: [],
      score: {},
      index: -1
    };
  },
  computed: {
    id() {
      // We will see what `params` is shortly
      return this.$route.params.id;
    },
    current_players() {
      return this.score.players;
    }
  },
  components: {
    Modal,
    Gamers,
    Score,
    ClassicButton
  },
  methods: {
    startDate(DateName) {
      let now = new Date();
      let JSOnnow = now.toJSON();
      this.$set(this.score, DateName, JSOnnow);
    },
    deleteDate(DateName) {
      this.$delete(this.score, DateName);
    },
    fetchData() {
      let index = -1;
      let id = this.$route.params.id;

      index = this.list_scores.findIndex(function(score) {
        return score.id === id;
      });

      if (index < 0) {
        this.$router.push("/");
      }
      this.index = index;
      this.score = this.list_scores[index];

      if (!this.score.startTime) {
        this.showModal = true;
      }

      //console.info(this.score.players);
    },
    updatePlayers(event) {
      //console.info('updatePlayers')
      this.score.players = event;
    },
    removeSheet(playerName) {
      this.score.details = this.score.details.filter(function(item) {
        return item.player != playerName;
      });
    }
  },
  mounted() {
    if (localStorage.getItem("skor_list_scores")) {
      this.list_scores = JSON.parse(localStorage.getItem("skor_list_scores"));
    }
    this.fetchData();
  },
  watch: {
    list_scores: {
      handler() {
        localStorage.setItem(
          "skor_list_scores",
          JSON.stringify(this.list_scores)
        );
      },
      deep: true
    },
    id: {
      handler() {
        // react to route changes...
        // something to do but not now
        this.fetchData();
      },
      deep: true
    },
    current_players: {
      handler() {
        // react to route changes...
        // something to do but not now
      },
      deep: true
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    //this.fetchData();
  }
};
</script>
